module.exports = __webpack_public_path__ + "img/notification-filled.0bee9f03.svg";